import { createAction } from '@reduxjs/toolkit'
import {
   CHANGE_LANG,
   GET_BANNERS,
   REMOVE_BANNER,
   SAVE_BANNERS,
   SET_BANNERS,
   SET_BANNER_STATE
} from './const'
import { TRemoveBannerPayload, TSaveBannersPayload } from './types'

export const bannerActions = {
   changeLang: createAction(CHANGE_LANG, (payload) => ({ payload })),
   getBanners: createAction(GET_BANNERS, (payload) => ({ payload })),
   setBanners: createAction(SET_BANNERS, (payload) => ({ payload })),
   removeBanner: createAction(REMOVE_BANNER, (payload: TRemoveBannerPayload) => ({
      payload
   })),
   saveBanners: createAction(SAVE_BANNERS, (payload: TSaveBannersPayload) => ({
      payload
   })),
   setBannerState: createAction(SET_BANNER_STATE, (payload) => ({ payload }))
}
